import getLocalString from "constants/Localization";
import { GetProductGroupsDocument, useCreateProductGroupMutation } from "generated/graphql";
import { usePaginatedVariables } from "hooks/strings/usePaginatedVariables";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateProductGroup() {
  const { offset } = usePaginatedVariables();
  const [mutation, { data, loading, error }] = useCreateProductGroupMutation({
    refetchQueries: [
      {
        query: GetProductGroupsDocument,
        variables: {
          page: offset.page,
          first: offset.first,
        },
      },
    ],
  });

  const [createProductGroup, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createProductGroup",
    },
    {
      successMessage: getLocalString("product-groups.create-success"),
      failureMessage: getLocalString("product-groups.create-failure"),
    }
  );

  return [createProductGroup, context] as const;
}
